// src/components/AdminProtectedRoute.js
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { db } from "../firebase";
import { ref, onValue } from "firebase/database";

export default function AdminProtectedRoute({ children }) {
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    const adminRef = ref(db, "sessions/admin/loggedIn");
    const unsub = onValue(adminRef, (snap) => {
      const isLogged = snap.val();
      setAllowed(isLogged === true);
    });
    return () => unsub();
  }, []);

  if (allowed === null)
    return (
      <div style={{ textAlign: "center", marginTop: 60 }}>
        <h3>Checking admin access...</h3>
      </div>
    );

  if (!allowed) return <Navigate to="/" replace />;

  return children;
}
